"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

var _mergeProperties = _interopRequireDefault(require("./mergeProperties"));

var _default = function _default(_ref) {
  var _ref$namespace = _ref.namespace,
      namespace = _ref$namespace === void 0 ? "" : _ref$namespace,
      properties = _ref.properties,
      objectType = _ref.objectType;
  var namespaceStr = namespace && namespace.length ? namespace + "/" : "";
  return (0, _defineProperty2.default)({}, "" + namespaceStr + _ActionTypes.default.STAGE_FOR_EDIT + "/" + objectType, function _(state, action) {
    var staged = action.payload[objectType];
    return (0, _mergeProperties.default)(properties, state, staged);
  });
};

exports.default = _default;
module.exports = exports.default;